import { QueryObserver } from '../../../query-core/build/modern/queryObserver.js';
import { useBaseQuery } from './useBaseQuery.js';

function useQuery(options,queryClient){return useBaseQuery(options,QueryObserver,queryClient)}

export { useQuery };
//# sourceMappingURL=useQuery.js.map
